export class EventEmitter {
  #events;
  on(type, listener) {
    let events;
    let existing;
    events = this.#events;
    if (events === void 0) {
      events = this.#events = /* @__PURE__ */ Object.create(null);
    } else {
      existing = events[type];
    }
    if (existing === void 0) {
      events[type] = listener;
    } else if (typeof existing === "function") {
      events[type] = [existing, listener];
    } else {
      existing.push(listener);
    }
  }
  off(type, listener) {
    const events = this.#events;
    if (events === void 0) {
      return;
    }
    const list = events[type];
    if (list == void 0) {
      return;
    }
    if (list === listener) {
      delete events[type];
    } else if (typeof list !== "function") {
      const index = list.indexOf(listener);
      if (index !== -1) {
        if (list.length === 2) {
          events[type] = list[index === 0 ? 1 : 0];
        } else {
          list.splice(index, 1);
        }
      }
    }
  }
  emit(type, ...args) {
    const events = this.#events;
    if (events === void 0) {
      return;
    }
    const handler = events[type];
    if (handler === void 0) {
      return;
    }
    if (typeof handler === "function") {
      handler.apply(this, args);
    } else {
      const handlers = handler.slice();
      for (let idx = 0, len = handlers.length; idx < len; idx++) {
        handlers[idx].apply(this, args);
      }
    }
  }
}
